import { EntityListContentItem } from '../entityListTypes';
import { EntityListContentStructure } from './EntityListContentStructure';

export class SkuEntityListContentStructure implements EntityListContentStructure {
  getContentTableStructure(): EntityListContentItem[] {
    return [EntityListContentItem.PRODUCT, EntityListContentItem.STORE];
  }

  getContentObjectPath(contentItem: EntityListContentItem): string[] {
    // eslint-disable-next-line @typescript-eslint/switch-exhaustiveness-check -- rest is covered by default branch
    switch (contentItem) {
      case EntityListContentItem.STORE:
        return ['sku', 'store'];
      case EntityListContentItem.PRODUCT:
        return ['sku', 'product'];
      default:
        throw new Error(`Unknown content item: ${contentItem}`);
    }
  }
}
